// © Microsoft Corporation. All rights reserved.
import { ContentSocialBar } from "./content-social-bar/ContentSocialBar";
import ReactionMenu from "./common/reaction-menu/ReactionMenu";
import SocialBarPanel from "./common/social-bar-panel/SocialBarPanel";

import {
    SocialBarExperienceRenderErrorContentSocialBar,
    SocialBarExperienceRenderErrorReactionMenu,
    SocialBarExperienceRenderErrorSocialBarPanel,
    SocialBarExperienceRenderErrorUnknownComponent
} from "@msnews/diagnostics";

export const RenderErrors = {
    [ContentSocialBar.name]: SocialBarExperienceRenderErrorContentSocialBar,
    [ReactionMenu.name]: SocialBarExperienceRenderErrorReactionMenu,
    [SocialBarPanel.name]: SocialBarExperienceRenderErrorSocialBarPanel,
    UnknownComponent: SocialBarExperienceRenderErrorUnknownComponent
};